import { Outlet } from 'react-router';
import { Header } from '@/layouts/components';

export const RegLoginLayout = () => {
  return (
    <>
      <Header routerMode='reg' />

      <Outlet />
    </>
  );
};
